import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'react-bootstrap';
import moment from 'moment';
import { FaBullhorn, FaPowerOff, FaCheck } from 'react-icons/fa';
import NivelBadge from '../NivelBadge';

const CORES = {
    INATIVO_BG: '#f8d7da',
    INATIVO_TEXT: '#721c24',
    CHAMADA: '#ebffe8',
    ENCAMINHADA: '#fff3cd',
    EM_ATENDIMENTO: '#65D1C2',
    FINALIZADO: '#d6d8db',
};

const SenhaGrid = ({ senhas, onRecall, onToggle, onEncaminhar, senhaRechamada }) => {
    const formatHora = data => {
        if (!data) return '-';
        return moment(data).format('HH:mm:ss');
    };

    const getRowStyle = senha => {
        if (!senha.is_ativo) {
            return {
                backgroundColor: CORES.INATIVO_BG,
                color: CORES.INATIVO_TEXT,
            };
        }
        if (senha.data_fim) {
            return {
                backgroundColor: CORES.FINALIZADO,
            };
        }
        if (senha.data_atendimento) {
            return {
                backgroundColor: CORES.EM_ATENDIMENTO,
            };
        }
        if (senha.numero_mesa) {
            return {
                backgroundColor: CORES.ENCAMINHADA,
            };
        }
        if (senha.data_chamada) {
            return {
                backgroundColor: CORES.CHAMADA,
            };
        }
        return {};
    };

    const podeEncaminhar = senha => {
        return senha.is_ativo &&
            senha.data_chamada &&
            !senha.numero_mesa &&
            !senha.data_atendimento &&
            !senha.data_fim;
    };

    const podeChamarNovamente = senha => {
        return senha.is_ativo &&
            senha.data_chamada &&
            !senha.data_fim;
    };

    const podeToggle = senha => {
        return !senha.numero_mesa && !senha.data_atendimento && !senha.data_fim;
    };

    if (!senhas || senhas.length === 0) {
        return (
            <div className="text-center text-muted py-4">
                Nenhuma senha chamada ainda.
            </div>
        );
    }

    return (
        <>
        <style>{`
            .recall-row { animation: recall-row-piscar 0.8s ease-in-out infinite; }
            @keyframes recall-row-piscar {
                0%   { box-shadow: inset 0 0 0 100vw transparent; }
                50%  { box-shadow: inset 0 0 0 100vw #0747a6; color: #fff; }
                100% { box-shadow: inset 0 0 0 100vw transparent; }
            }
        `}</style>
        <div style={{ borderRadius: '8px', maxHeight: '400px', overflow: 'auto' }}>
            <Table bordered hover size="sm" className="mb-0">
                <thead style={{ backgroundColor: '#0747a6', color: '#fff', position: 'sticky', top: 0, zIndex: 1 }}>
                    <tr>
                        <th className="text-center">Senha</th>
                        <th className="text-center">Hora Chamada</th>
                        <th>Cliente</th>
                        <th className="text-center">Mesa</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {senhas.map(senha => (
                        <tr key={senha.codigo} style={getRowStyle(senha)} className={senha.codigo === senhaRechamada ? 'recall-row' : ''}>
                            <td className="text-center">
                                <NivelBadge isDiamante={senha.atendimento_preferencial} senha={senha.senha} />
                            </td>
                            <td className="text-center">{formatHora(senha.data_chamada)}</td>
                            <td>{senha.nome_cliente || '-'}</td>
                            <td className="text-center">{senha.numero_mesa || '-'}</td>
                            <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                {podeChamarNovamente(senha) && (
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        onClick={() => onRecall(senha.codigo)}
                                        title="Chamar novamente"
                                        className="mr-1"
                                        style={{ padding: '2px 6px' }}
                                    >
                                        <FaBullhorn />
                                    </Button>
                                )}
                                {podeToggle(senha) && (
                                    <Button
                                        variant={senha.is_ativo ? 'danger' : 'info'}
                                        size="sm"
                                        onClick={() => onToggle(senha.codigo)}
                                        title={senha.is_ativo ? 'Inativar' : 'Re-ativar'}
                                        className="mr-1"
                                        style={{ padding: '2px 6px' }}
                                    >
                                        <FaPowerOff />
                                    </Button>
                                )}
                                {podeEncaminhar(senha) && (
                                    <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => onEncaminhar(senha.codigo)}
                                        title="Encaminhar"
                                        style={{ padding: '2px 6px' }}
                                    >
                                        <FaCheck />
                                    </Button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
        </>
    );
};

SenhaGrid.propTypes = {
    senhas: PropTypes.arrayOf(
        PropTypes.shape({
            codigo: PropTypes.number.isRequired,
            senha: PropTypes.number.isRequired,
            data_chamada: PropTypes.string,
            nome_cliente: PropTypes.string,
            numero_mesa: PropTypes.number,
            is_ativo: PropTypes.bool,
            data_atendimento: PropTypes.string,
            data_fim: PropTypes.string,
            atendimento_preferencial: PropTypes.bool,
        })
    ),
    onRecall: PropTypes.func.isRequired,
    onToggle: PropTypes.func.isRequired,
    onEncaminhar: PropTypes.func.isRequired,
};

SenhaGrid.defaultProps = {
    senhas: [],
};

export default SenhaGrid;